import { CustomEdge } from './CustomEdge'

export const SCENARIO_ELEMENT_EDGE_TYPES = {
  custom: CustomEdge,
}
